import { useDispatch } from "react-redux";
import useLogoutBase from "@wine2trace/auth/useLogout";
import axios from "../api/axios";
import { clearSessionState } from "../services/clearLocalSession";

// Logout volontario (@wine2trace/auth) piu' la pulizia dello stato Redux della sessione.
const useLogout = () => {
  const dispatch = useDispatch();
  return useLogoutBase({ api: axios, onClear: () => clearSessionState(dispatch) });
};

export default useLogout;
